import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import VueCookies from 'vue-cookies'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
import vueSwiper from 'vue-awesome-swiper' // 引入vue-awesome-swiper
import 'swiper/dist/css/swiper.css' // 引入样式
import './assets/css/global.css'
import JsonViewer from 'vue-json-viewer'
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-light.css'// 样式
import formatDate from './assets/basic/formatDate.js' // 日期格式化
import echarts from 'echarts'
import Utils from './common/utils.js'
import VueIziToast from 'vue-izitoast'
import 'izitoast/dist/css/iziToast.css'
import 'izitoast/dist/css/iziToast.min.css'
import MetaInfo from 'vue-meta-info'

Vue.prototype.$layer = layer(Vue)
Vue.prototype.utils = Utils
Vue.use(VueCookies)
Vue.use(vueSwiper) // 使用插件
Vue.use(JsonViewer)
Vue.use(VueIziToast)
Vue.use(MetaInfo)

Vue.prototype.$formatDate = formatDate

Vue.prototype.$echarts = echarts

axios.defaults.baseURL = store.state.rootUrl + 'api'

axios.interceptors.request.use(config => {
  if (store.state.login_time) {
    const currentTime = parseInt(Date.parse(new Date()) / 1000)
    if (store.state.login_time + (60 * 60 * 12) < currentTime) {
      router.push('/login')
    }
  }

  if (config.url !== '/api-token-auth/') {
    const token = store.state.token
    config.headers.common.Authorization = 'Token ' + token
  }
  return config
})
axios.interceptors.response.use(function (response) {
  return response.data
})

// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})
Vue.directive('highlight', function (el) {
  const blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    hljs.highlightBlock(block)
  })
})

Vue.prototype.$http = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
